import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
require('parsley');
export class memberTermsConditions {

    pageDown():any {
        let valueOfCheckbox = $(".terms-and-conditions-checkbox");
        $(valueOfCheckbox).each(function(index:any){
            let $checkboxVal = $(this);
                if($checkboxVal.val() === 'true' ) {
                    let $id =   $checkboxVal.attr('data-accordian-id'); 
                    // $checkboxVal.attr({''}); 
                    $('#'+$id).collapse('show');
                }
        });
    }
}
let scope:Element = document.querySelector('.member-terms-conditions');
if(scope){
    try{
        let membertermsconditions = new memberTermsConditions();
        membertermsconditions.pageDown();

    }catch(e){console.error(e);}
}
// let membertermsconditions = new memberTermsConditions();
